export const BASE_URL =
  process.env.NODE_ENV === 'development'
    ? (process.env.REACT_APP_API_DEV_URL ?? 'http://localhost:3000') + '/api'
    : (process.env.REACT_APP_API_PROD_URL ?? 'http://localhost:3000') + '/api'
export const BASE_SOCKET_URL =
  process.env.NODE_ENV === 'development'
    ? process.env.REACT_APP_API_DEV_URL ?? 'http://localhost:3000'
    : process.env.REACT_APP_API_PROD_URL ?? 'http://localhost:3000'

// export const BASE_URL = 'https://newboard2sill12.xyz/api'
// export const BASE_SOCKET_URL = 'https://newboard2sill12.xyz/'

export enum serverPath {
  LOGIN = '/auth/login',
  REFRESH = '/auth/refresh',
  CRM = 'crm',
  CRM_PERMISSIONS = '/crm/permission',
  CRM_USERS = 'crm/users',
  CRM_ADD = 'crm/add-crm',
  MAIN_STAT = 'crm/statistic',
  USERS = 'crm/users',
  USERS_MANAGER = 'users',
  USER_INFO = 'crm/users/',
  USER_TABLE = 'crm/user-table/',
  CRM_INFO = 'crm/statistic/',
  CRM_SUBSCRIPTIONS = 'crm/subscriptions/',
  CRM_PAYMENTS = 'crm/billing/info/',
  SALARY = 'salary',
  SALARY_INCOMES = 'salary/incomes',
  SALARY_EXPENSES = 'salary/expenses',
  SALARY_REPORTS = 'salary/reports',
  USER_CREATE = 'auth/create',
  BASES_LIGHT = '/bases/light',
  USERS_LIGHT = '/users/light',
  SERVER_EXPIRED = '/crm/server',
  BILLING = '/crm/billing/info',
  BILLING_SERVICES = '/balance',
  CRM_PRICE = '/crm/price',
  CRM_PLANS = '/crm/plans',
  CRM_BALANCE = '/crm/balance',
  SEARCH_TEXT = '/search/text',
  SEARCH_USER = '/search/user/',
  TARIFFS = '/tariffs',
  COUNTRY = '/country',
  CRM_COUNTRIES = '/crm/country',
  HASH = '/auth/generate-hash',
  AUTOMATION = '/automation',
  AUTOMATION_TASKS = '/automation/tasks',
  CABINET_INFO = '/cabinets/:cabinetId',
  CABINETS_INFO = '/cabinets',
  ACTIVATE_CABINET = '/cabinets/:cabinetId/active',
  DELETE_CABINET = '/cabinets/:cabinetId',
  DOMAINS_LIST = '/cabinet-domains',
  ACTIVATE_DOMAIN = '/cabinet-domains/:domainId/active'
}
